import React from "react"
import Box from "@mui/material/Box"
import { SxProps, Theme } from "@mui/material"
import { ReactNode } from "react"

interface MediaContainerProps {
  sx?: SxProps<Theme>
  children: ReactNode
}

export default function MediaContainer({ sx, children }: MediaContainerProps) {
  return (
    <Box
      sx={{
        position: "relative",
        justifySelf: "center",
        width: 1,
        maxWidth: 720,
        aspectRatio: 1,
        borderRadius: 2,
        overflow: "hidden",
        mx: "auto",
        bgcolor: "rgba(0,0,0,0.25)",
        boxShadow: "0px 8px 10px rgba(0,0,0,0.25)",
        ...(sx as object),
      }}
    >
      {children}
    </Box>
  )
}
